import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './HowCan.css'
import ContactForm from '../ContactForm';

function HowCan() {

 

  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Contact Us</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>How Can <span>We Help</span> </h2>
              <p>Mobile Application, Website Solution, Digital Transformation, Customized  IT Software, we are here to help you achieve your objective. Please let  us know and our team of experts will meet you to take things further.</p>
            </div> 
            <ContactForm/>
           {/* <div className='hmslder-img'>
              <form>
                  <h4>Tell us about your project</h4>
                  <div className='form-group'>
                    <input type='text' placeholder='Name'/>
                    <div className='con-phn'>
                      <select value={countryCode} onChange={handleCountryCodeChange}>
                        <option value="+974">+974 (QA)</option>
                        <option value="+971">+971 (UAE)</option>
                        <option value="+91">+91 (IN)</option>
                        <option value="+973">+973 (BH)</option>
                      </select>
                      <input
                        type="tel"
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        placeholder="Phone Number"
                      />
                    </div>
                  </div>
                  <div className='form-group'>
                    <input type='email' placeholder='Email'/>
                    <input type='text' placeholder='Subject'/>
                  </div>
                  <div className='form-group'>
                    <textarea placeholder='Describe your project'></textarea>
                  </div>
                  <button className='btn-main'><span>Submit</span> <FaChevronRight/> </button>
               </form>
            </div>   */}
        </div>
    </section>
  )
}

export default HowCan
